
<!-- <span>{{data}}</span>  -->

<!-- <mat-spinner diameter="80" color="warn" ></mat-spinner> -->

<div class="capa-load">
<div class="loading">
  <div class="dot"></div>
  <div class="dot"></div>
  <div class="dot"></div>
  <div class="dot"></div>
</div>
</div>
 